"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var ConfiguratorContext = /*#__PURE__*/_react["default"].createContext({
  data: null,
  configuration: null,
  setConfiguration: null,
  isAuthorOrAdmin: null,
  translate: null,
  getPrice: null,
  getDayPeriodImage: null
});

var _default = ConfiguratorContext;
exports["default"] = _default;